module.exports = __webpack_public_path__ + "static/urbanite-d2.1-text-only-68d486a857bf3ea52881ca81a237c605.pdf";